module.exports = __webpack_public_path__ + "img/profile_credential_009.72672040.png";